<template>
    <div>
        <leaflet-map-catalogs-button @activated="onActivated"></leaflet-map-catalogs-button>
        <leaflet-map-background-layers-button @activated="onActivated"></leaflet-map-background-layers-button>        
    </div>
</template>
<script>
	import LeafletMapBackgroundLayersButton from "./LeafletMapBackgroundLayersButton";
	import LeafletMapCatalogsButton from "./LeafletMapCatalogsButton";
	
	export default {
		components: {
			LeafletMapBackgroundLayersButton,
			LeafletMapCatalogsButton
		},
		data() {
			return {
				buttons: []
			}
		},
		mounted() {
			this.buttons = this.$children;
		},
		methods: {
			onActivated(activeButton) {
				this.buttons.forEach((button) => {
					if (button !== activeButton)
					    button.isActive = false;
				});
			}
		}
	};
</script>